import { Cache } from 'axios-extensions'
import { gotToMilliSecond } from '@helper/utils'

export const HOME_DATA = new Cache({ ttl: gotToMilliSecond(1440), ttlAutopurge: true })
export const TUTOR_LIST = new Cache({ ttl: gotToMilliSecond(15), ttlAutopurge: true })
export const TUTOR_PROFILE = new Cache({ ttl: gotToMilliSecond(15), ttlAutopurge: true })
export const IMPORTANT_CITIES = new Cache({ ttl: gotToMilliSecond(1440), ttlAutopurge: true })
export const IMPORTANT_COURSE_HEADER = new Cache({ ttl: gotToMilliSecond(1440), ttlAutopurge: true })
export const TESTIMONIALS_HOME = new Cache({ ttl: gotToMilliSecond(1440), ttlAutopurge: true })
export const STATISTICS_HOME = new Cache({ ttl: gotToMilliSecond(720), ttlAutopurge: true })
export const BEAST_TEACHER = new Cache({ ttl: gotToMilliSecond(720), ttlAutopurge: true })
export const COUNTRIES_LIST = new Cache({ ttl: gotToMilliSecond(1440), ttlAutopurge: true })
export const COURSE_LIST = new Cache({ ttl: gotToMilliSecond(20), ttlAutopurge: true })
export const ACTIVE_TEACHER_FORUM = new Cache({ ttl: gotToMilliSecond(120), ttlAutopurge: true })
